import InputForm from './InputForm';
import SelectForm from './SelectForm';
import InputNumberForm from './InputNumberForm';
import CascaderForm from './CascaderForm';
import DateForm from './DateForm';
import TreeSelectForm from './TreeSelectForm';
export const getMessage = (type = 1) => {
    let message = {
        1: '请输入',
        2: '请选择',
        3: '请输入',
        4: '请选择',
        5: '请选择',
        6: '请选择'
    };
    return message[type];
};
import { rules } from 'grt-tool-lib-front';
const { checkIsIdentity } = rules;

//验证规则
export const getRules = (props) => {
    const { field_type = 1, setting = {} } = props,
        rules = [],
        [min = 0, max = 100] = setting?.number_range || [];
    if (props.required === 0) {
        rules.push({ required: true, message: getMessage(props.field_type) });
    }
    //文本类型 --当前仅有文本类型有其他的规则限制
    if (field_type === 1 && setting.type !== 'tag') {
        if (setting.maxLength) {
            rules.push({ max: setting.maxLength, message: `最多输入${setting.maxLength}字` });
        }
    }
    //数值类型
    if (field_type === 3) {
        rules.push({
            validator: (_, value) => {
                if (!value && value !== 0) {
                    return Promise.resolve();
                }
                if (value < min) {
                    return Promise.reject({ field: props.en_name, message: `不能小于${min}` });
                }
                if (value > max) {
                    return Promise.reject({ field: props.en_name, message: `不能大于${max}` });
                    // return Promise.reject(`不能大于${max}`);
                }
                return Promise.resolve();
            }
        });
    }
    if (props.en_name === 'id_card') {
        rules.push({
            validator: (_, value) => {
                if (!value) {
                    return Promise.resolve();
                }
                return checkIsIdentity(value).catch((err) => {
                    return Promise.reject(new Error(err));
                });
            }
        });
    }

    return rules;
};
//根据类型 选择不同的表单  // 1-文本 2-下拉 3-数值 4-级联 5-日期 6 -上传
export const getForm = (props) => {
    let { field_type = 1 } = props;
    switch (field_type) {
        case 2:
            return SelectForm(props);
        case 3:
            return InputNumberForm(props);
        case 4:
            return CascaderForm(props);
        case 5:
            return DateForm(props);
        case 7:
            return TreeSelectForm(props);
        default:
            return InputForm(props);
    }
};
